import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import {
    ApiRequestService,
    CustomerOrderSummary,
    DateUtilPipe,
    DialogService,
    OrderPackageDisplayComponent,
    StatusOption,
    TranslationPipe,
    TranslationService
} from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetProductsResponse } from '../../products/product-list/get-products.response';
import { Material } from '../../products/product-list/material.model';
import { OrderService } from './../order.service';
import { CreateinvoiceDialogComponent } from './createinvoicedialog/createinvoicedialog.component';
import { CreateInvoiceDialogResult } from './createinvoicedialog/createinvoicedialogresult';
import { CreateInvoiceRequest } from './createinvoicedialog/createinvoicerequest';
import { DeliveryOption } from './deliveryoption';
import { Filter } from './filter';
import { FilterOrdersRequest } from './filterOrdersRequest';
import { GetOrdersResponse } from './get-orders-response.model';
import { GetOrderDetailsRequest } from './getorderdetailsrequest';
import { GetOrderDetailsResponse } from './getorderdetailsresponse';
import { GetOrdersRequest } from './getOrdersRequest';
import { OrderDate } from './orderdate';
import { OrderWithDate } from './orderwithdate';
import { PaymentStatus } from './paymentstatus';
import { TimeInterval } from './timeinterval';
import { MarkOrderAsOpenedRequest } from './use-cases/mark-order-as-opened.request';
import { MarkOrderAsOpenedUseCase } from './use-cases/mark-order-as-opened.usecase';

@Component({
    selector: 'app-getorders',
    templateUrl: './getorders.component.html',
    styleUrls: ['./getorders.component.scss'],
    standalone: true,
    imports: [FormsModule, MatIconModule, MatFormFieldModule, MatSelectModule, MatChipsModule, CommonModule, TranslationPipe, DateUtilPipe, OrderPackageDisplayComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GetordersComponent implements OnInit {
    private static readonly ACTIVE_ORDERS_SHEETNAME = 'active_orders_';
    private static readonly ARCHIVE_ORDERS_SHEETNAME = 'archive_orders_';

    dateForm?: FormGroup;
    deliveryOption = DeliveryOption.ALL;
    disableDate = false;
    endDateElement = '';
    @ViewChild('endDateElementInput') endDateElementInput!: ElementRef;
    EXCEL_EXPORT_URI = '/admin/exportExcel';
    filteredOrder: OrderWithDate[] = [];
    filterElement: Filter = {
        orderStatus: StatusOption.ALL,
        deliveryOption: DeliveryOption.ALL,
        productId: 0,
        clerkPaymentStatus: PaymentStatus.ALL,
        isArchivedSearch: false,
        orderReference: ''
    };
    findOrderByOrderReferenceUrl = '/admin/find-order-by-orderreference';
    getInvoiceURI = '/admin/getInvoice';
    getOrdersUrl = '/admin/getOrders';
    orderReferenceModel = '';
    isArchivedSearch = false;
    isPaymentSuccessful = false;
    isPreorder = false;
    isSearchAboutOrderReference = true;
    isSearchActive = false;
    name = '';
    nofilter = false;
    numberOfActiveOrders = 0;
    orderBackendUrl = '';
    orderDate = OrderDate.LAST_TWO_MONTHES;
    orderReference: any;
    orders: OrderWithDate[] = [];
    ordersAccordingTodeliveryOptions = [DeliveryOption.FOXPOST, DeliveryOption.STORE_PICKUP, DeliveryOption.MPL, DeliveryOption.ALL];
    ordersAccordingToOrderDate = [OrderDate.LAST_TWO_MONTHES, OrderDate.LAST_MONTH];
    ordersAccordingToPaymentStatus = [PaymentStatus.SUCCESSFUL, PaymentStatus.PAY_ON_STORE, PaymentStatus.FAIL, PaymentStatus.ALL];
    ordersAccordingToStatuses = [
        StatusOption.WAITING_FOR_PROCESSING,
        StatusOption.UNFINISHED,
        StatusOption.ALL,
        StatusOption.FINISHED,
        StatusOption.PREORDER,
        StatusOption.DELETED
    ];
    ordersType = [OrderDate.LAST_TWO_MONTHES, OrderDate.LAST_MONTH];
    paymentStatus = PaymentStatus.ALL;
    productId = 0;
    products: Material[] = [];
    settingModifiedDates = false;
    settingupdates = false;
    startDateElement = '';
    @ViewChild('startDateElementInput') startDateElementInput!: ElementRef;
    status = StatusOption.ALL;
    storeBaseUrl = '';
    storeExistingProductsURI = '/store/get-products';
    expandedOrderReference: string | null = null;
    expandedOrderDetails: CustomerOrderSummary[] = [];
    expandedOrderLoading = false;
    getOrderDetailsUrl = '/admin/getOrderDetails';
    createInvoiceURI = '/admin/createInvoice';

    private _dialogService = inject(DialogService);
    private _markOrderAsOpenedUseCase = inject(MarkOrderAsOpenedUseCase);

    constructor(
        private _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _orderService: OrderService,
        private _translateService: TranslationService,
        private _cdr: ChangeDetectorRef
    ) {
        this.orderBackendUrl = _orderBackendUrl;
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this.getProducts();

            this.getOrders();
        } else {
            this._router.navigateByUrl('/');
        }
    }

    private scrollToSavedOrder(): void {
        if (this.orderReference) {
            setTimeout(() => {
                const el = document.getElementById(this.orderReference);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    el.style.color = 'red';
                }
            }, 100);
        }
    }

    getProducts(): void {
        this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.storeExistingProductsURI).subscribe((response) => {
            const products = response as GetProductsResponse;
            this.products = products.productList as Material[];
        });
    }

    getOrders(): void {
        if (sessionStorage.getItem('orderReference')) {
            this.orderReference = JSON.parse(sessionStorage.getItem('orderReference') as string) as string;
        }

        if (sessionStorage.getItem('numberOfActiveOrders')) {
            this.numberOfActiveOrders = JSON.parse(sessionStorage.getItem('numberOfActiveOrders') as string) as number;
        }
        if (sessionStorage.getItem('filterElement')) {
            this.filterElement = JSON.parse(sessionStorage.getItem('filterElement') as string) as Filter;

            this.filter();
        } else {
            this.getLastTwoMonthOrders();
        }
    }

    filter(): void {
        this.findFilteredOrder(this.createFilterOrderRequest());
    }

    findFilteredOrder(filterOrderRequest: GetOrdersRequest): void {
        this._apiRequestService
            .sendRequest<GetOrdersRequest, GetOrdersResponse>(this.orderBackendUrl, filterOrderRequest, true, this.getOrdersUrl)
            .subscribe((response) => {
                const filteredOrder = response.orderList as OrderWithDate[];
                this.filteredOrder = filteredOrder;
                const filterElement: Filter = {
                    orderStatus: filterOrderRequest.orderStatus,
                    deliveryOption: filterOrderRequest.deliveryOption,
                    startDate: filterOrderRequest.startDate,
                    endDate: filterOrderRequest.endDate,
                    productId: filterOrderRequest.productId,
                    clerkPaymentStatus: filterOrderRequest.clerkPaymentStatus,
                    isArchivedSearch: filterOrderRequest.isArchivedSearch,
                    name: filterOrderRequest.name,
                    orderReference: this.orderReferenceModel,
                    modifiedStartDate: filterOrderRequest.modifiedStartDate,
                    modifiedEndDate: filterOrderRequest.modifiedEndDate
                };
                sessionStorage.setItem('filterElement', JSON.stringify(filterElement));
                this._cdr.markForCheck();
                this.scrollToSavedOrder();
            });
    }

    createFilterOrderRequest(): FilterOrdersRequest {
        const filterOrderRequest: GetOrdersRequest = {
            orderStatus: this.filterElement.orderStatus,
            deliveryOption: this.filterElement.deliveryOption,
            startDate: this.filterElement.startDate,
            endDate: this.filterElement.endDate,
            productId: this.filterElement.productId,
            clerkPaymentStatus: this.filterElement.clerkPaymentStatus,
            isArchivedSearch: this.filterElement.isArchivedSearch,
            name: this.filterElement.name,
            orderReference: this.orderReferenceModel,
            modifiedStartDate: this.filterElement.modifiedStartDate,
            modifiedEndDate: this.filterElement.modifiedEndDate
        };

        return filterOrderRequest;
    }

    getLastTwoMonthOrders(): void {
        this._apiRequestService
            .sendRequest<{}, GetOrdersResponse>(this.orderBackendUrl, {}, true, this.getOrdersUrl)
            .subscribe((response) => {
                this.orders = response.orderList as OrderWithDate[];
                this.numberOfActiveOrders = this.orders.length;
                sessionStorage.setItem('numberOfActiveOrders', JSON.stringify(this.orders.length));
                this.filteredOrder = this.orders;
                sessionStorage.setItem('filterElement', JSON.stringify(this.filterElement));
                this._cdr.markForCheck();
                this.scrollToSavedOrder();
            });
    }

    toggleArchiveSearch(): void {
        this.filterElement.isArchivedSearch = !this.filterElement.isArchivedSearch;
    }

    exportToExcel(isActive: boolean): void {
        const excelExportURI = this.EXCEL_EXPORT_URI + '?active=' + isActive;

        const sheetName = isActive ? GetordersComponent.ACTIVE_ORDERS_SHEETNAME : GetordersComponent.ARCHIVE_ORDERS_SHEETNAME;

        this._apiRequestService.sendRequestBlob(this.orderBackendUrl, {}, true, excelExportURI, true).subscribe((blobData: any) => {
            const now = new Date();
            const blob = new Blob([blobData], { type: 'application/vnd.ms-excel' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.setAttribute('target', 'blank');
            a.href = url;
            a.download =
                sheetName +
                now.toLocaleDateString('en-us', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    timeZone: 'UTC'
                });
            +'.xls';

            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        });
    }

    setDates(): void {
        this.settingupdates = !this.settingupdates;
    }

    setModifiedDates(): void {
        this.settingModifiedDates = !this.settingModifiedDates;
    }

    collectDates(): TimeInterval | null {
        const startDate = this.startDateElement;
        const endDate = this.endDateElement;
        this.startDateElement = startDate?.replace(/\D/g, '-');
        this.endDateElement = endDate?.replace(/\D/g, '-');
        let timeInterval: TimeInterval | null;
        if (startDate !== '' && endDate !== '') {
            timeInterval = {
                startDate: this.startDateElement,
                endDate: this.endDateElement
            };
        } else {
            timeInterval = null;
        }

        return timeInterval;
    }

    onChangeListfilter(): void {
        if (this.name !== '') {
            this.disableDate = true;
        } else {
            this.disableDate = false;
        }
    }

    searchAboutOnChangeOnDates(): void {
        this.isSearchAboutOrderReference = false;
        this.name = '';
    }

    searchAboutOnChangeOnOrderReference(): void {
        this.isSearchAboutOrderReference = true;
        this.startDateElementInput.nativeElement.value = '';
        this.endDateElementInput.nativeElement.value = '';
        this.startDateElement = '';
        this.endDateElement = '';
    }

    findOrderDetailsByOrderReference(order: OrderWithDate): void {
        sessionStorage.setItem('isArchive', JSON.stringify(order.archive));

        this._router.navigate(['/getorders', order.orderReference!], { queryParams: { inv: order.invoiceAvailable } });
    }

    scrollToFragment(): void {
        this._router.navigate([], { fragment: this.orderReference });
        document.getElementById(this.orderReference)!.style.color = 'red';
        window.location.hash = '';
    }

    getStatusLabel(status: string | undefined | null): string {
        if (!status) return '';
        return this._translateService.translate('admin.' + status);
    }

    getPaymentLabel(paymentStatus: string | undefined | null): string {
        if (!paymentStatus) return '';
        return this._translateService.translate('payment.' + paymentStatus);
    }

    openInvoice(orderReference: string): void {
        this._orderService.openInvoice(orderReference);
    }

    refreshPage(): void {
        if (sessionStorage.getItem('filterElement')) {
            sessionStorage.removeItem('filterElement');
        }

        this.filterElement = {
            orderStatus: StatusOption.ALL,
            deliveryOption: DeliveryOption.ALL,
            productId: 0,
            clerkPaymentStatus: PaymentStatus.ALL,
            isArchivedSearch: false,
            orderReference: this.orderReferenceModel,
            modifiedStartDate: undefined,
            modifiedEndDate: undefined
        };

        this.getLastTwoMonthOrders();
    }

    toggleOrderDetails(order: OrderWithDate): void {
        if (this.expandedOrderReference === order.orderReference) {
            this.expandedOrderReference = null;
            this.expandedOrderDetails = [];
            this._cdr.markForCheck();
            return;
        }

        this.expandedOrderReference = order.orderReference!;
        this.expandedOrderLoading = true;
        this.expandedOrderDetails = [];
        this._cdr.markForCheck();

        this._markOrderAsOpened(order);

        const request: GetOrderDetailsRequest = {
            orderReference: order.orderReference,
            archive: order.archive
        };

        this._apiRequestService
            .sendRequest<GetOrderDetailsRequest, GetOrderDetailsResponse>(
                this.orderBackendUrl, request, true, this.getOrderDetailsUrl
            )
            .subscribe({
                next: (response) => {
                    this.expandedOrderDetails = response.customerOrderSummaryList as CustomerOrderSummary[];
                    this.expandedOrderDetails.forEach(detail => {
                        detail.previousStatus = detail.status;
                    });
                    this.expandedOrderLoading = false;
                    this._cdr.markForCheck();
                },
                error: () => {
                    this.expandedOrderLoading = false;
                    this.expandedOrderReference = null;
                    this._cdr.markForCheck();
                }
            });
    }

    private _markOrderAsOpened(order: OrderWithDate): void {
        if (order.clerkOpened || !order.orderReference) {
            return;
        }

        order.clerkOpened = true;
        this._cdr.markForCheck();

        const request: MarkOrderAsOpenedRequest = {
            orderReference: order.orderReference
        };

        (this._markOrderAsOpenedUseCase.execute(request) as Observable<void>).subscribe();
    }

    onInlineStatusChanged(event: { orderReference: string; newStatus: string; applyToAll: boolean }, order: OrderWithDate): void {
        const orderInList = this.filteredOrder.find(o => o.orderReference === order.orderReference);
        if (orderInList) {
            orderInList.status = event.newStatus;
        }
        this._cdr.markForCheck();
    }

    shouldShowInvoiceButton(order: OrderWithDate): boolean {
        if (order.invoiceAvailable) {
            return false;
        }

        const paymentSuccess = order.paymentStatus === 'SUCCESS';
        const hasFinishedDetail = this.expandedOrderDetails?.some(d => d.status === 'FINISHED');

        return paymentSuccess || !!hasFinishedDetail;
    }

    loadCreateInvoiceDialog(orderReference: string): void {

        this._dialogService.openDialog(
            CreateinvoiceDialogComponent,
            null,
            ((createInvoiceDialogResult: CreateInvoiceDialogResult | undefined) => {
                this.createInvoice(
                    orderReference,
                    createInvoiceDialogResult?.paymentOption,
                    createInvoiceDialogResult?.paymentDate
                );
                const orderInList = this.filteredOrder.find(o => o.orderReference === orderReference);
                if (orderInList) {
                    orderInList.invoiceAvailable = true;
                }
                this._cdr.markForCheck();
            })
        );
    }

    createInvoice(orderReference: string, paymentOption: string | undefined, paymentDate: string | undefined) {
        const createInvoiceRequest: CreateInvoiceRequest = {
            orderReference: orderReference,
            paymentOption: paymentOption,
            paymentDate: paymentDate
        };
        this._apiRequestService
            .sendRequest<CreateInvoiceRequest, HttpResponse<any>>(
                this.orderBackendUrl,
                createInvoiceRequest,
                true,
                this.createInvoiceURI
            )
            .subscribe();
    }
}
